import { render, staticRenderFns } from "./ReivindicacaoTabelaDash.vue?vue&type=template&id=29ba444f&lang=html&"
import script from "./ReivindicacaoTabelaDash.vue?vue&type=script&lang=js&"
export * from "./ReivindicacaoTabelaDash.vue?vue&type=script&lang=js&"
import style0 from "./ReivindicacaoTabelaDash.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../../../../shared-components/generico/Pagination.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/ReivindicacaoTabelaDash.vue
// module id = 1236
// module chunks = 28